import { ItemOnPopup } from "../../general_components/content_management/reusableItems/itemOnPopup";
import { priceOnFinish, percentageTypingProcess, priceTypingProcess } from "../../supplementary_components/priceInputDelegate";
import { addPopup } from "../../supplementary_components/store";
import { dateFormatter } from "../../supplementary_components/supplementaryMethods";
import { dateStringToLocalDateString } from "../reports/weeklyReports";

/** Returns default object for a new custom job, based on columns from jobsTableConfigByPaymentType (excluding dragger). */
export function getDefaultCustomJob(paymentType, currentStatement) {
    const endDate = currentStatement?.period?.endDate ?? new Date().toISOString().slice(0, 10);
    if (paymentType === "PerMile") {
        return {
            customJob: true,
            endDate,
            deadhead: 0,
            origin: "",
            mileage: 0,
            destination: "",
            perMileRate: 0,
            share: 1,
            payout: 0
        };
    }
    if (paymentType === "Percentage") {
        return {
            customJob: true,
            endDate,
            loadNumber: "",
            origin: "",
            destination: "",
            loadRate: 0,
            payout: 0
        };
    }
    return { customJob: true };
}

export function jobsTableConfigByPaymentType(paymentType, numericOnBlur, rateFormat, removeRecord, currentStatement, setCurrentStatement, updateDataset){
    return paymentType === "PerMile" ? {
            headerPresent:true,
            reorderingAllowed:true,
            customWidth: "99%",
            columns:[
                {
                    width: "2%",
                    label: "",
                    dragger: true
                },
                endDateColumn(updateDataset, currentStatement, setCurrentStatement),
                {
                    width: "6.66%",
                    label: "DH Miles",
                    name: "deadhead",
                    alignment: "center",
                    editable:true,
                    customFormat:parseInt,
                    onEdit: (val)=>{
                        return val.replace(/[^0-9]/g,'')
                    },
                    onBlur: (tag)=>{
                        numericOnBlur(tag, parseInt);
                    },
                    onPaste: (val)=>{
                        return val.replace(/[^0-9]/g,'')
                    }
                },
                {
                    width:  "30%",
                    label: "Origin",
                    name: "origin",
                    onBlur: (element, data, index)=>{
                        updateDataset(currentStatement, "jobsArray", setCurrentStatement, index, "origin", element.value, 0);
                    }
                },
                {
                    width: "6.66%",
                    label: "Loaded Miles",
                    name: "mileage",
                    alignment: "center",
                    editable:true,
                    customFormat:parseInt,
                    onEdit: (val)=>{
                        return val.replace(/[^0-9]/g,'')
                    },
                    onBlur: (tag)=>{
                        numericOnBlur(tag, parseInt);
                    },
                    onPaste: (val)=>{
                        return val.replace(/[^0-9]/g,'')
                    }
                },
                {
                    width:  "30%",
                    label: "Destination",
                    name: "destination",
                    onBlur: (element, data, index)=>{
                        updateDataset(currentStatement, "jobsArray", setCurrentStatement, index, "destination", element.value, 0);
                    }
                },
                {
                    width: "6.66%",
                    label: "Per Mile Rate",
                    name: "perMileRate",
                    alignment: "center",
                    customFormat: rateFormat,
                    editable:true,
                    onEdit: priceTypingProcess,
                    onBlur: (tag)=>{
                        numericOnBlur(tag, parseFloat, rateFormat);
                    },
                    onPaste: priceOnFinish
                },
                {
                    width:  "10%",
                    label: "Payout",
                    name: "payout",
                    alignment: "right",
                    editable:true,
                    calculation: (data)=>{
                        return rateFormat(data["payout"]);
                    } ,
                    editInputStyle:(element, data)=>{
                        if(!data['payoutManuallyEntered'] && data['share'] !== 1.0){
                            element.style.width = '50%';
                            element.style.color = "var(--light-gray)";
                            element.onfocus = (e) => {
                                e.target.style.color = "var(--dark-gray)";
                            }
                        }
                        
                    },
                        
                    cellEdit: (element, data, index)=>{
                        let constant = true;
                        if(data.payoutManuallyEntered || data.payoutEditable)constant = false;
                        if(!data.payoutManuallyEntered && data['share'] !== 1.0){
                            element.className += "doubleInput";
                            constant = false;
                            const input = document.createElement("input");
                            input.type = "text";
                            input.style.width = "50%";
                            input.style.textAlign = "right";
                            input.defaultValue = (parseFloat((data['share']*100).toFixed(2)))+'%'
                            input.dataset.index = index;
                            input.dataset.name = "share";
                            input.oninput = (e)=>{
                                e.target.value = percentageTypingProcess(e.target.value)
                            }
                            input.onblur = (e)=>{
                                numericOnBlur(e.target, (val)=>{
                                    return parseFloat(val)/100
                                }, (val)=>{
                                    const formatted = parseFloat((val * 100).toFixed(2));
                                    return percentageTypingProcess(`${formatted}`);
                                })
                            }
                            element.appendChild(input);
                        }
                        let button = document.createElement("button");
                        button.className = "button dismiss";
                        button.onclick = () => {
                            removeRecord(currentStatement, "jobsArray", setCurrentStatement, index, 0)
                        };
                        element.appendChild(button);
                        return constant;
                    },
                    onBlur: (tag)=>{

                        tag.style.color = "var(--light-gray)";
                        numericOnBlur(tag, parseFloat, rateFormat);
                    },
                    
                },
            ]
        }
    : paymentType === "Percentage" ? {
        headerPresent:true,
        reorderingAllowed:true,
        customWidth: "99%",
        columns:[
            {
                width: "2%",
                label: "",
                dragger: true
            },
            endDateColumn(updateDataset, currentStatement, setCurrentStatement),
            {
                width:  "15%",
                label: "Load Number",
                name: "loadNumber",
                cellEdit: (element, data, index) => {
                    if (data.id) {
                      const span = document.createElement("span");
                      span.textContent = data.loadNumber ?? "";
                      span.style.cursor = "pointer";
                      span.className = "clickableloadnumber";
                      // optional: reuse itemOnPopup.module.scss clickableItem class
                      span.onclick = () => {
                        addPopup({
                          content: ItemOnPopup,
                          popupData: { itemType: "load", itemId: data.id },
                          customWidth: "90%",
                          customMaxWidth: "1700px",
                          customMinWidth: "880px",
                          EZCloseAllowed: true,
                        });
                      };
                      element.innerHTML = "";
                      element.appendChild(span);
                      return true; // don't make it an input
                    }
                    // custom job without load id → fall through to editable input
                    return false;
                  },
                onBlur: (element, data, index)=>{
                    updateDataset(currentStatement, "jobsArray", setCurrentStatement, index, "loadNumber", element.value, 0);
                }
            },
            {
                width:  "25%",
                label: "Origin",
                name: "origin",
                onBlur: (element, data, index)=>{
                    updateDataset(currentStatement, "jobsArray", setCurrentStatement, index, "origin", element.value, 0);
                }
            },
            {
                width:  "25%",
                label: "Destination",
                name: "destination",
                onBlur: (element, data, index)=>{
                    updateDataset(currentStatement, "jobsArray", setCurrentStatement, index, "destination", element.value, 0);
                }
            },
            {
                width:  "15%",
                label: "Load Rate",
                name: "loadRate",
                customFormat: (value) => {
                    if (value == null || (typeof value === "number" && Number.isNaN(value))) {
                        return "N/A";
                    }
                    return rateFormat(value);
                },
                editable:true,
                cellEdit: (element, data, index)=>{
                    return false;
                },
                editInputStyle: (element, data) => {
                    if (data.loadRate == null) {
                        element.style.color = "var(--alert-color)";
                        element.style.fontWeight = "700";
                    }
                    element.onfocus = (e) => {
                        if (data.loadRate == null || e.target.value === "N/A") {
                            e.target.value = "";
                            e.target.style.color = "";
                            e.target.style.fontWeight = "";
                        }
                    };
                },
                onBlur: (tag, data, index)=>{
                    const cleaned = tag.value.replace(/[^0-9.]/g, "");
                    const wasNull = data.loadRate == null;
                    const parsed = cleaned === "" ? NaN : parseFloat(cleaned);

                    if (Number.isNaN(parsed)) {
                        if (wasNull) {
                            tag.value = "N/A";
                            tag.style.color = "var(--alert-color)";
                            tag.style.fontWeight = "700";
                            return;
                        }
                        numericOnBlur(tag, parseFloat, rateFormat);
                        return;
                    }

                    if (!updateDataset(currentStatement, "jobsArray", setCurrentStatement, index, "loadRate", parsed, 0)) {
                        tag.value = rateFormat(parsed);
                        tag.style.color = "";
                        tag.style.fontWeight = "";
                    }
                },
                onEdit: priceTypingProcess,
                onPaste: priceOnFinish,
            },
            {
                width:  "10%",
                label: `Payout (${currentStatement.driver.percentageFromGross*100}%)`,
                name: "payout",
                alignment: "right",
                customFormat: rateFormat,
                cellEdit:(element, data, index)=>{
                    let button = document.createElement("button");
                    button.className = "button dismiss";
                    button.onclick = () => {
                        removeRecord(currentStatement, "jobsArray", setCurrentStatement, index, 0)
                    };
                    element.appendChild(button);
                    return true;
                }
                
            }
        ]
    }:paymentType === "Salary" ? {
        headerPresent:true,
        customWidth: "99%",
        columns:[
            {
                width:  "58%",
                label: "Week Day",
                name: "weekDay"
            },
            {
                width:  "16%",
                label: "Status",
                name: "status",
                cellEdit: (element, data, index)=>{
                    const selectTag = document.createElement("select");
                    let option = document.createElement("option");
                    option.value = "On Duty";
                    option.innerText = "On Duty";
                    selectTag.appendChild(option);
                    option = document.createElement("option");
                    option.value = "Off Duty";
                    option.innerText = "Off Duty";
                    if(data["status"] === "Off Duty"){
                        option.selected = true;
                        selectTag.style.color = "var(--alert-color)"
                    }
                    selectTag.appendChild(option);
                    option = document.createElement("option");
                    option.value = "Layover";
                    option.innerText = "Layover";
                    if(data["status"] === "Layover"){
                        option.selected = true;
                    }
                    selectTag.appendChild(option);
                    selectTag.onchange = (e) =>{
                        const newVal = e.target.value;
                        selectTag.style.color = newVal === "Off Duty" ? "var(--alert-color)" : "var(--dark-gray)";
                        updateDataset(currentStatement, "jobsArray", setCurrentStatement, index, "status", newVal, 0);
                    }
                    element.innerHTML = "";
                    element.appendChild(selectTag);
                    return true;
                }
            },
            {
                width:  "16%",
                label: "Shift Utilization",
                name: "shiftUtilization",
                editable: true,
                dataRequiredForCustomFormatting: true,
                customFormat: (val, data)=>{
                    if(data.status !== "Layover"){
                        return percentageTypingProcess(`${val*100}`)
                    }else{
                        return val <= 1 ? "" : val;
                    }
                    
                },
                cellEdit: (element, data, index) => {
                    if(data.status === "Off Duty"){
                        element.innerText = "-";
                        return true;
                    }else if(data.status === "Layover"){
                    }
                },
                onEdit: (val, data)=>{
                    return data.status === "Layover" ? val : percentageTypingProcess(val);
                },
                onBlur: (tag, data, index)=>{
                    if(data.status !== "Layover"){
                        numericOnBlur(tag, (val)=>{
                            return parseFloat(val)/100 > 1 ? 1 : parseFloat(val)/100;
                        }, (val)=>{
                            return percentageTypingProcess(`${val * 100}`);
                        })
                    }else{
                        updateDataset(currentStatement, "jobsArray", setCurrentStatement, index, "shiftUtilization", tag.value, 0);
                        return 
                    }
                   
                },
                onPaste: (val, data)=>{
                    return data.status === "Layover" ? val : percentageTypingProcess(val);
                }
            },
            {
                width:  "10%",
                label: "Payout",
                name: "payout",
                alignment: "right",
                editable: true,
                customFormat: rateFormat,
                cellEdit: (element, data, index) => {
                    if(data.status !=="Layover"){
                        return true;
                    }else{
                        return false
                    }
                },
                onBlur: (tag)=>{
                    numericOnBlur(tag, parseFloat, rateFormat);
                    // updateDatasetUsingTag(currentStatement, "jobsArray", setCurrentStatement, tag, parseFloat(tag.value.replace(/[^0-9.]/g,'')))
                },
                onEdit: priceTypingProcess,
            },
        ]
        
    }
    :{}
}
const endDateColumn = (updateDataset, currentStatement, setCurrentStatement) => {
    return {
        width: "8%",
        label: "Date",
        name: "endDate",
        alignment: "center",
        customFormat: (value)=>{
            const date = new Date(value+" 00:00");
            return date.toLocaleDateString("en-US", { day: 'numeric', month: 'numeric', year: "2-digit" })
        },
        cellEdit : (newElement, data, index)=>{
            if(data.incompleteLoad){
                newElement.innerHTML += "<br /><span class='unfinished'>(Unfinished)</span>"
            }
            return false;
        },
        onBlur: (element, data, index)=>{
            let newVaulue = dateFormatter(element.value);
            if(newVaulue.date){
                newVaulue = dateStringToLocalDateString(newVaulue.date);
                if(newVaulue !== data.endDate){
                    updateDataset(currentStatement, "jobsArray", setCurrentStatement, index, "endDate", newVaulue, 0);
                    return;
                }
            }else{
                newVaulue = data.endDate
            }
            const date = new Date(newVaulue+" 00:00");
            element.value = date.toLocaleDateString("en-US", { day: 'numeric', month: 'numeric', year: "2-digit" })
        }
    }
}